import React from "react";
import {Navigation} from "swiper/modules";
import {Swiper, SwiperSlide} from "swiper/react";
import "../../../style/common/components/swiper/message_template_swiper.scss";

interface MessageTemplateSwiperProps {
    templateList:SampleMessageDto[];
    onSelectedMessage:(msg:string) => void;
}

const MessageTemplateSwiper:React.FC<MessageTemplateSwiperProps> = (
    {
        templateList = [],
        onSelectedMessage = () => {}
    }
) => {
    if(templateList && templateList.length > 0) {
        return (
            <Swiper spaceBetween={20}
                    slidesPerView={3}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    modules={[Navigation]}
                    breakpoints={{
                        768: {slidesPerView: 3}
                    }}
                    className="message-template-swiper"
            >
                {templateList.map( ((templateDto, idx) => (<SwiperSlide key={`slide_message_template_item_${idx}`}>
                    <dl className={`message-template-item`} onClick={() => {onSelectedMessage(templateDto.sample_message)}}>
                        <dt>{templateDto.title}</dt>
                        <dd dangerouslySetInnerHTML={{ __html: templateDto.sample_message.replace(/<br\s*\/?>/g, '\n').replace(/\n/g, '<br />')}}></dd>
                    </dl>
                </SwiperSlide>)))}
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </Swiper>
        );
    }else {
        return <></>;
    }
}
export default MessageTemplateSwiper;